import axios from "axios";
const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME || "http://localhost:9000";
const cleanDomain = DOMAIN_NAME.replace(/\/+$/, "");
const API_URL = cleanDomain + "/api/auth/";

var browserDomain = API_URL;

try {
  if (window.location.protocol === 'https:') {
    browserDomain = API_URL;
  } else {
    const url = new URL(window.location.href);
    const setDomain = new URL(cleanDomain);

    if (url.hostname !== setDomain.hostname) {
      const port = setDomain.port ? `:${setDomain.port}` : '';
      browserDomain = `${url.protocol}//${url.hostname}${port}/api/auth/`;
    } else {
      browserDomain = API_URL;
    }
  }
} catch (e) {
  browserDomain = API_URL;
}

class AuthService {
  login(username, password) {
    return axios
      .post(browserDomain + "signin", {
        username,
        password
      }, {
        withCredentials: true
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
    return axios
      .post(browserDomain + "signOut", {}, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      });
  }

  register(username, email, password) {
    return axios.post(browserDomain + "signup", {
      username,
      email,
      password
    });
  }

  editRole(username, roles) {
    return axios
      .post(browserDomain + "editPermission", {
        username,
        roles
      }, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      });
  }

  deleteUser(username) {
    return axios
      .post(browserDomain + "deleteUser", {
        username
      }, {
        withCredentials: true
      })
      .then(response => {
        return response.data;
      });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));;
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;